/* i18n — same approach as bookify-pro: dictionaries keyed by source string + a translate() that reads the language from the store */

import { store } from "../store"

import ru from "./ru"
import kk from "./kk"

/* Default export — all dictionaries */
export default { ru, kk }

/* Supported languages */
export const languages = [
    { text: "Русский", code: "ru" },
    { text: "Қазақша", code: "kk" }
]

/* Translate a source (Russian) string into the current language */
export const translate = value => {
    const language = store.getState().lang
    const dictionaries = { ru, kk }

    if (typeof value === "string" && `${language}` in dictionaries) {
        const dictionary = dictionaries[`${language}`]
        if (`${value}` in dictionary) {
            return dictionary[`${value}`]
        }
    }

    return value
}
